export const billings = {
  sendCartItems(lineItems, userId, email, paymentId) {
    return this.httpInstance.post('/billing/savePayment', {
      lineItems, userId, email, paymentId,
    });
  },
  createCheckoutSession(data) {
    return this.httpInstance.post('/billing/create-checkout-session', data);
  },
  verifyPayment(data) {
    return this.httpInstance.post('/billing/verify-payment', data);
  },
};
